var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1529 11.1241C14.9194 11.3541 14.8121 11.6869 14.8653 12.0132L15.6667 16.5232C15.7343 16.9055 15.5757 17.2923 15.261 17.5132C14.9527 17.7424 14.5425 17.7699 14.2063 17.5866L10.2135 15.4691C10.0746 15.3939 9.92047 15.3536 9.76271 15.349H9.5184C9.43365 15.3618 9.35072 15.3893 9.27499 15.4315L5.28128 17.5591C5.08384 17.6599 4.86027 17.6956 4.6412 17.6599C4.1075 17.5572 3.7514 17.0402 3.83885 16.4948L4.6412 11.9848C4.69439 11.6557 4.58711 11.3211 4.35362 11.0874L1.09824 7.87906C0.825987 7.61048 0.731328 7.20715 0.855737 6.84323C0.97654 6.48023 1.28486 6.21531 1.65718 6.15573L6.13771 5.49481C6.47849 5.45906 6.77779 5.24823 6.93105 4.93656L8.90537 0.820729C8.95225 0.729063 9.01265 0.644729 9.08567 0.573229L9.16681 0.509063C9.20918 0.461396 9.25786 0.421979 9.31195 0.389896L9.41022 0.353229L9.56347 0.289062H9.94301C10.282 0.324813 10.5804 0.531063 10.7363 0.839063L12.7368 4.93656C12.881 5.23631 13.1614 5.4444 13.4851 5.49481L17.9656 6.15573C18.3442 6.21073 18.6607 6.47656 18.786 6.84323C18.9041 7.21081 18.8022 7.61415 18.5245 7.87906L15.1529 11.1241Z",
    fill: "#FF8F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/Star_icon.79e90d1bc069ef3a7ca6e4cfb941c5e2.svg";
export { ForwardRef as ReactComponent };